/* unplugin-vue-components disabled */import { render } from "./MultipleSelect.vue?vue&type=template&id=b0d50638&scoped=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&lang=js"

import "./MultipleSelect.vue?vue&type=style&index=0&id=b0d50638&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d50638"]])

export default __exports__